import React from 'react';
import PublicHeader from './PublicHeader';
import PublicFooter from './PublicFooter';

interface PublicLayoutProps {
  children: React.ReactNode;
  className?: string;
}

const PublicLayout: React.FC<PublicLayoutProps> = ({
  children,
  className = '',
}) => {
  return (
    <div
      className={`min-h-screen bg-brand-background text-secondary-900 dark:bg-secondary-950 dark:text-white ${className}`}
    >
      <PublicHeader />
      <main>{children}</main>
      <PublicFooter />
    </div>
  );
};

export default PublicLayout;
